var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center"},[_c('FrSpinner',{staticClass:"mb-4",attrs:{"label":"Spinning"}}),_c('div',{staticClass:"text-center text-muted w-100"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }